export default "__VITE_ASSET__CDDTiBSl__"